module.exports = __webpack_public_path__ + "wine_tour.86dde07e98a63a705d7c72d636daf90c.png";